import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsAPI, { ReviewablePendingBookDto } from '../../api/MeetingsAPI';
import PrimaryButton from '../PrimaryButton/PrimaryButton';

interface PendingBookingsButtonProps {
  onOpenSlideOver: () => void;
}

export default function PendingBookingsButton({ onOpenSlideOver }: PendingBookingsButtonProps) {
  const { t } = useTranslation();
  const [, setMeetings] = useState<ReviewablePendingBookDto[]>([]);
  const [notificationCount, setNotificationCount] = useState<number>(0);

  const fetchPendingMeetings = async () => {
    try {
      const response = await MeetingsAPI.pendings();
      setMeetings(response.data.meetings);
      setNotificationCount(response.data.meetings.length);
    } catch (error) {
      console.error('Failed to fetch pending meetings:', error);
    }
  };

  useEffect(() => {
    fetchPendingMeetings();

    const handlePendingMeetingsUpdated = () => {
      fetchPendingMeetings();
    };

    window.addEventListener('pendingMeetingsUpdated', handlePendingMeetingsUpdated);

    return () => {
      window.removeEventListener('pendingMeetingsUpdated', handlePendingMeetingsUpdated);
    };
  }, []);

  const handleClick = () => {
    onOpenSlideOver();
  };

  return (
    <PrimaryButton
      fn={handleClick}
      text={t("calendar.incoming_meetings.button")!}
      actionName="See Reservation Requests"
      notificationCount={notificationCount}
    />
  );
}